import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://localhost:7206';
const ENV = import.meta.env.VITE_ENV || 'development';
const TIMEOUT = 30000;

const apiClient = axios.create({
  baseURL: `${API_URL}/api`, // Add /api to base URL
  timeout: TIMEOUT,
  headers: {
    'Accept': '*/*',
    'Content-Type': 'application/json',
  },
});

// Request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    if (ENV === 'development') {
      console.log(`[${ENV}] API Request:`, {
        method: config.method.toUpperCase(),
        fullUrl: `${config.baseURL}${config.url}`,
        data: config.data,
        params: config.params,
      });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for logging
apiClient.interceptors.response.use(
  (response) => {
    if (ENV === 'development') {
      console.log(`[${ENV}] API Response:`, {
        status: response.status,
        data: response.data,
      });
    }
    return response;
  },
  (error) => {
    if (ENV === 'development') {
      console.error(`[${ENV}] API Error:`, {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
    }
    return Promise.reject(error);
  }
);

export default apiClient;